import {includes} from '@shared/helpers/collection'
import {isEmpty} from '@shared/helpers/lang'

import {getFamilyPayPaymentInfo} from '@web/actions/familyPay'
import {CustomOrders} from '@web/core/constants'
import makeSlice from '@web/slices/agreement/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {data} = payload

                const thirdPeople = data.containsTraditionalAlcohol ?? false
                const personalDataCrossBorderTransfer =
                    data.personalDataCrossBorderTransferAgreementMerchantsByMerchantNo
                const customOrder = data.products.some(({customOrderDetailType}) =>
                    includes(customOrderDetailType, CustomOrders),
                )
                const preOrderStatus = data.products.some(({preOrder}) => !!preOrder)

                state.mallContract = false
                state.thirdPeople = thirdPeople
                state.personalDataCrossBorderTransfer = !isEmpty(personalDataCrossBorderTransfer)
                    ? personalDataCrossBorderTransfer
                    : null
                state.customOrder = customOrder
                state.preOrder = preOrderStatus
                state.enabled = false
                state.openBankingAgreed = data.agreement?.agreedOpenBank ?? true

                const isFamilyPayApiFailed = data.familyPay?.apiResultType === 'FAILED'
                const familyPayAgreed = data.familyPay?.familyPayAgreement ?? true

                state.familyPayAgreed = isFamilyPayApiFailed ? undefined : familyPayAgreed

                state.selected = {
                    mallContract: true,
                    thirdPeople: !thirdPeople,
                    customOrder: !customOrder,
                    preOrder: !preOrderStatus,
                    personalDataCrossBorderTransfer: isEmpty(personalDataCrossBorderTransfer),
                    /** 패밀리결제 정보 api가 실패했거나 패밀리결제 기동의자는 true로 처리 */
                    familyPay: isFamilyPayApiFailed || familyPayAgreed,
                    booking: true,
                    shoppingSubscription: true,
                }
            })
            .addCase(getFamilyPayPaymentInfo.fulfilled, (state, {payload}) => {
                const isApiFailed = payload.apiResultType === 'FAILED'

                state.selected = {
                    ...state.selected,
                    /** 패밀리결제 정보 api가 실패했거나 패밀리결제 기동의자는 true로 처리 */
                    familyPay: isApiFailed || payload.familyPayAgreement,
                }
                state.familyPayAgreed = isApiFailed ? undefined : payload.familyPayAgreement
            })
    },
})

export default slice.reducer
